import type { Theme } from '@mui/material';
import type { TriageActionAccent } from 'src/graphql/entities/conversation-triage-run';

export function getAccentColor(accent: TriageActionAccent, theme: Theme): string {
  const map: Record<TriageActionAccent, string> = {
    urgency: theme.palette.warning.main,
    status: theme.palette.info.main,
    type: theme.palette.primary.main,
    group: theme.palette.custom.OV.sys.onSurfaceVariant,
    assignee: theme.palette.custom.OV.sys.onSurfaceVariant,
    default: theme.palette.custom.OV.sys.onSurfaceVariant,
  };
  return map[accent];
}
